let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("gWXGh")).then(() => parcelRequire('j3Vfq'));